// src/config/publicLinks.js

function clean(value) {
  return String(value || "").trim();
}

export const BRAND_NAME = clean(process.env.REACT_APP_BRAND_NAME) || "LocReach";

export const LEGAL_ENTITY_NAME =
  clean(process.env.REACT_APP_LEGAL_ENTITY_NAME) || "THAMES TECH AI LIMITED";

export const COMPANY_NUMBER =
  clean(process.env.REACT_APP_COMPANY_NUMBER) || "15466271";

export const REGISTERED_OFFICE =
  clean(process.env.REACT_APP_REGISTERED_OFFICE) || "66 Paul Street, London, EC2A 4NA";

export const SUPPORT_EMAIL =
  clean(process.env.REACT_APP_SUPPORT_EMAIL) || "support@locreach.ai";

export const PRIVACY_EMAIL =
  clean(process.env.REACT_APP_PRIVACY_EMAIL) || SUPPORT_EMAIL;

export const PUBLIC_CONTACT_URL =
  clean(process.env.REACT_APP_PUBLIC_CONTACT_URL) || `mailto:${SUPPORT_EMAIL}`;

export const SALES_CONTACT_URL =
  clean(process.env.REACT_APP_SALES_CONTACT_URL) || PUBLIC_CONTACT_URL;